import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import iconFile from "../img/icons/icon-file.svg";
import MemberSidebar from "../inc/MemberSidebar";
import {jwtDecode} from "jwt-decode";

export default function ScholarshipDetail(prop) {
    let navigate = useNavigate();
    let {slug} = useParams();

    let [detail, setDetail] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);
        let memberTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(memberTokens) {
            let memberJson = jwtDecode(JSON.parse(memberTokens).accessToken);
            let checkExpireHrs = (Math.abs(new Date().getTime() - new Date(memberJson.latestLoginAt).getTime()) / 3600000);
            if(checkExpireHrs > Utils.HOURS_EXPIRE_LOGIN) {
                navigate((prop.lang === 'en' ? '/en':'/') + 'login');
            }
        }
        else {
            window.location.href = (prop.lang === 'en' ? '/en':'/') + 'login';
        }

        (async function() {
            try {
                const resDetail = await getDetail();
                if(prop !== null && prop.lang === 'en') {
                    resDetail.title = resDetail.title_en;
                    resDetail.detail = resDetail.detail_en;
                    resDetail.agency = resDetail.agency_en;
                    resDetail.year = resDetail.year_en;
                    resDetail.framework = resDetail.framework_en;
                    resDetail.period = resDetail.period_en;
                    resDetail.criterion = resDetail.criterion_en;
                }
                setDetail(resDetail);
                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/scholarship/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="scholarship" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3">{detail?.title}</h2>

                                <div className="article"
                                     style={{'--text-strong-color':'#111','--text-color':'#8E8E8E','--title-color':'#2A2B71'}}>

                                    {
                                        detail?.image ? <p className="text-center"><img src={Config.fileUpload + 'scholarship/' + detail?.image} alt={detail?.title} /></p> : ''
                                    }

                                    <table>
                                        {
                                            detail?.agency !== null ?
                                                <tr>
                                                    <td style={{width: '130px'}}><h6 className="m-0">หน่วยงานให้ทุน :</h6></td>
                                                    <td>{detail?.agency}</td>
                                                </tr> : ''
                                        }
                                        {
                                            detail?.year !== null ?
                                                <tr>
                                                    <td style={{width: '130px'}}><h6 className="m-0">ปีที่ให้ทุน :</h6></td>
                                                    <td>{detail?.year}</td>
                                                </tr> : ''
                                        }
                                        {
                                            detail?.framework !== null ?
                                                <tr>
                                                    <td style={{width: '130px'}}><h6 className="m-0">กรอบวิจัย :</h6></td>
                                                    <td>{detail?.framework}</td>
                                                </tr> : ''
                                        }
                                    </table>
                                    {
                                        detail?.detail !== null ?
                                            <>
                                                <hr />

                                                <h3>{prop.lang === 'en' ? 'Research Question':'โจทย์วิจัย'}</h3>
                                                <div dangerouslySetInnerHTML={{__html: detail?.detail}}></div>
                                            </> : ''
                                    }

                                    {
                                        detail?.period !== null ?
                                            <>
                                                <div className="py-sm-1">
                                                    <hr />
                                                </div>

                                                <h3>{prop.lang === 'en' ? 'Offer acceptance period':'ช่วงเวลารับข้อเสนอฯ'}</h3>
                                                <p>{detail?.period}</p>
                                            </> : ''
                                    }

                                    {
                                        detail?.criterion !== null ?
                                            <>
                                                <h3>{prop.lang === 'en' ? 'Criteria for consideration of preliminary project proposals':'หลักเกณฑ์การจัดสรรทุนวิจัยและการพิจารณาให้ทุนวิจัย'}</h3>
                                                <div dangerouslySetInnerHTML={{__html: detail?.criterion}}></div>
                                            </> : ''
                                    }

                                    {
                                        detail?.scholarshipFile ?
                                            <>
                                                <h3>{prop.lang === 'en' ? 'Download documents':'ดาวน์โหลดเอกสารที่เกี่ยวข้อง'}</h3>
                                                <ul className="nav nav-download-list">
                                                    {
                                                        detail.scholarshipFile.map((rs, index) => {
                                                            return (
                                                                <li key={index} >
                                                                    <NavLink download to={Config.fileUpload + 'scholarship_file/' + rs.file} target="_blank">
                                                                        <img className="icons svg-js" src={iconFile} alt="" />
                                                                        <span className="link-underline">{prop.lang === 'en' ? rs.title_en:rs.title}</span>
                                                                    </NavLink>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </> : ''
                                    }

                                    <div className="py-2"></div>
                                    <div className="card-primary text-center" data-aos="fade-in"> 
                                        <div className="buttons p-0">
                                            <NavLink className="btn btn-secondary" to={(prop.lang === 'en' ? '/en/':'') + '/proposal/create/' + Utils.encodeItem({scholarshipId: detail?.id})}>
                                                <span className="px-4">ยื่นขอรับทุนวิจัย</span>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 